// Third Party
import React from 'react';

// Components
import EditBenchmark from '../edit-benchmark/EditBenchmark';
import BenchmarkPortfolio from '@/types/benchmark-portfolio';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  show: boolean;
  onCancel: () => void;
  onSave: (benchmarkPortfolio: BenchmarkPortfolio) => Promise<void>;
  showCurrencies: boolean;
};

const EditBenchmarkModal = ({ onSave, onCancel, show, showCurrencies }: Props) => (
  <Modal show={show} className="edit-benchmark-modal" onHide={onCancel} dialogClassName="modal-dialog-centered" backdrop="static" keyboard={false}>
    <Modal.Body className="d-flex flex-column">
      <EditBenchmark onSave={onSave} onCancel={onCancel} showCurrencies={showCurrencies} />
    </Modal.Body>
  </Modal>
);

export default EditBenchmarkModal;
